import { $ } from './../../helpers/query';

export default () => {

  $('.photos-gray').each(section => {

    setPhotosSectionBackground();
    window.addEventListener('resize', setPhotosSectionBackground);

    function setPhotosSectionBackground() {
      if (document.documentElement.clientWidth >= 640) {

        $(section).css({
          'background-image': () => {

            const startColor = 'transparent';
            const finishColor = '#4A4D57';
            const frontier = ($('.photos-gray__right', section).height() / 2) * 100 / $(section).height();

            return `linear-gradient(to top, ${startColor} 0%, ${startColor} ${frontier}%, ${finishColor} ${frontier}%, ${finishColor} 100%)`;

          }
        })

      } else {
        $(section).css({
          'background-image': null
        });
      }
    }

  });

}
